import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { EmptyState as DefaultEmptyState } from 'shared/components';

const EmptyState = ({ search, Icon, emptyText }) => {
  const { t } = useContext(ConfigContext);

  return <DefaultEmptyState text={search ? t('noResults', { search }) : t(emptyText)} Icon={Icon} />;
};

export default EmptyState;
